import {
    type CombinedTokenData,
    useCombinedMultichainCollectionMetadata,
    useGetTokenMetadata,
    useNFTMainOwnerData,
    useTokenPricing,
    useTokenTraits,
} from '@pkg/hooks';

interface UseTokenInfoDataReturn {
    data: CombinedTokenData;
    isLoading: boolean;
}
export function useTokenInfoData(): UseTokenInfoDataReturn {
    const { data: mainNftDataRes, isLoading } = useGetTokenMetadata({}); // TODO: clean up this hook re. single item vs tokens list
    const mainNftData = mainNftDataRes?.[0];

    const { data: collectionMetadata } = useCombinedMultichainCollectionMetadata({
        slug: mainNftData?.slug || mainNftData?.collection_id || mainNftData?.collection,
        includeAttributes: true,
    });

    const traits = useTokenTraits({
        tokenAttributes: mainNftData?.attributes,
        collectionAttributes: collectionMetadata?.attributes,
        totalTokens: collectionMetadata?.tokenCount,
    });

    const { owner, data: ownerData } = useNFTMainOwnerData(mainNftData?.collection, mainNftData?.token_id);

    const tokenId = `${collectionMetadata?.chain}.${mainNftData?.collection}.${mainNftData?.token_id}`;
    const pricing = useTokenPricing({
        tokenIds: [tokenId],
    });

    // TODO - use owners call for total
    const owner_data: CombinedTokenData['owner_data'] = {
        owners: ownerData || [],
        owner: owner || {},
        total_owners: ownerData?.length || 0,
    };

    const data = {
        // TODO - add bought at & offer/bid details
        token_metadata: (mainNftData || {}) as CombinedTokenData['token_metadata'],
        collection_metadata: collectionMetadata || {},
        owner_data: owner_data || {},
        pricing,
        traits,
    };

    return { data, isLoading };
}
